import { render, staticRenderFns } from "./OccupationSkillForm.vue?vue&type=template&id=f88bd81e&scoped=true"
import script from "./OccupationSkillForm.vue?vue&type=script&lang=js"
export * from "./OccupationSkillForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88bd81e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f88bd81e')) {
      api.createRecord('f88bd81e', component.options)
    } else {
      api.reload('f88bd81e', component.options)
    }
    module.hot.accept("./OccupationSkillForm.vue?vue&type=template&id=f88bd81e&scoped=true", function () {
      api.rerender('f88bd81e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/referentiel/occupation-skill/OccupationSkillForm.vue"
export default component.exports